import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { COMMON_CONSTANTS } from '../common/core/common.constants';
import { HttpCacheService } from './http-cache.service';
import { AuthHttpService } from './http-wrapper.service';
import { HelperUtilityService } from './helper-utility.service';
@Injectable({
  providedIn: 'root',
})
export class ContentService {

  private static CacheFactory: any[] = [];

  constructor(private _authHttp: AuthHttpService, private _cacheSvc: HttpCacheService,
    private _helperUtilSvc: HelperUtilityService) { }

  public static SetCache(key, value) {
      this.CacheFactory[key] = value;
  }

  public static GetCache(key): any {
      return this.CacheFactory[key];
  }

  public static CleanCache(key): any {
    this.CacheFactory[key] = null;
    return this.CacheFactory[key];
}

  public GetContentData(url: string): Promise<any> {

    const accessToken = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY);
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + accessToken,
          'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'content-type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'transactionID': this._helperUtilSvc.getTransactionID(),
        },
      ),
    };
    return this._authHttp.get(url, httpOptions).toPromise();
  }

}
